import * as types from '../../mutation_type'
import getDate from '../../../../apis/api'
import {getCookie} from '../../../../../../util/util'

export default {
  CmpyinfoByReqdomain ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_CMPYINFOBYREQDOMAIN(params).then((res) => {
        resolve(res)
        commit(types.CMPYINFOBYREQDOMAIN, res)
      }).catch((thrown) => {
        console.log(thrown)
        reject(thrown);
      })
    })
  },
  getPubconfiginfo ({state, commit}, params) {
    return getDate.GET_PUBCONFIGINFO(params).then((res) => {
      commit(types.GETPUBCONFIGINFO, res)
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  getSysmarinfo ({state, commit}, params) {
    return getDate.GET_SYSMARINFO(params).then((res) => {
      commit(types.GETSYSMARINFO, res)
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  getAddress ({state, commit}, params) {
    return getDate.GET_ADDRESS(params).then((res) => {
      if (params.selIndex == 0) {
        commit(types.GETADDRESS, res)
      } else if (params.selIndex == 1) {
        commit(types.GETADDRESSCITY, res)
      } else {
        commit(types.GETADDRESSAREA, res)
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  getShoppingCart ({state, commit}, params) { // 获取购物车列表
    state.cartLoading = true // 加载中...
    return new Promise(function (resolve, reject) {
      return getDate.GET_SHOPPINGCART(params).then((res) => {
        state.cartLoading = false // 加载中...
        resolve(res)
      }).catch((thrown) => {
        reject(thrown)
      })
    })
  },
  removeCartItem ({state, commit}, params) { // 从购物车移除商品
    return getDate.GET_REMOVECARTITEM(params).then((res) => {
      if (params.selIndex == 0) {
        commit(types.GETADDRESS, res)
      } else if (params.selIndex == 1) {
        commit(types.GETADDRESSCITY, res)
      } else {
        commit(types.GETADDRESSAREA, res)
      }
    }).catch((thrown) => {
      console.log(thrown)
    })
  },
  getQuantityOfShoppingCart ({state, commit}) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_QUANTITYOFSHOPPINGCART().then((res) => {
        resolve(res)
      }).catch((thrown) => {
        reject(thrown)
      })
    })
  },
  getBrowseinfoList ({state, commit}, params) {
    if (getCookie('membercode')) {
      return getDate.GET_BROWSEINFOLIST(params).then((res) => {
        if (res.data.status == '001') {
          // 我的足迹列表获取成功
          state.browseinfoList = res.data.data
        }
      }).catch((thrown) => {
        console.log(thrown)
      })
    }
  },
  // 获取企业元素配置信息
  getSysconelementsinfo ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_SYSCONELEMENTSINFO(params).then((res) => {
        sessionStorage.setItem('elementsInfo', JSON.stringify(res.data))
        resolve(res)
      }).catch((thrown) => {
        reject(thrown)
      })
    })

  },
  // 获取企业的预售基础服务配置
  getSysPresellConfigInfo ({state, commit}, params) {
    return new Promise(function (resolve, reject) {
      return getDate.GET_SYSPRESELLCONFIGINFO(params).then((res) => {
        resolve(res)
      }).catch((thrown) => {
        reject(thrown)
      })
    })

  },
}



// WEBPACK FOOTER //
// ./src/pages/GenRedOne/store/modules/common/actions/actions.js